import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
interface FaqItemProps extends React.ComponentProps<'div'> {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  question: string;
  answer: string;
}
function FaqItem(t0) {
  const $ = _c(22);
  let Icon;
  let answer;
  let className;
  let props;
  let question;
  if ($[0] !== t0) {
    ({
      icon: Icon,
      question,
      answer,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = answer;
    $[3] = className;
    $[4] = props;
    $[5] = question;
  } else {
    Icon = $[1];
    answer = $[2];
    className = $[3];
    props = $[4];
    question = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("flex flex-col gap-2", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== Icon) {
    t2 = <div data-slot="faq-icon" className="bg-primary/10 flex size-9 shrink-0 items-center justify-center rounded-full"><Icon className="text-primary size-4" /></div>;
    $[8] = Icon;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== question) {
    t3 = <h3 data-slot="faq-question" className="text-foreground text-lg leading-[120%] font-bold">{question}</h3>;
    $[10] = question;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className="flex items-center gap-3">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== answer) {
    t5 = <p data-slot="faq-answer" className="text-foreground text-base/6 font-normal">{answer}</p>;
    $[15] = answer;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== props || $[18] !== t1 || $[19] !== t4 || $[20] !== t5) {
    t6 = <div data-slot="faq-item" className={t1} {...props}>{t4}{t5}</div>;
    $[17] = props;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
export { FaqItem };